import { EAppsCounters, ERefsApps } from '@enums';

import { EAppsGenreEng } from '@base/enums';

export const MAX_APPS_FOR_SHOW_MORE = 3;

export const orderedGenres = [
	{
		genre: EAppsGenreEng.ROLEPLAY,
		counter: EAppsCounters.SHOW_MORE_ROLEPLAY,
		ref: ERefsApps.LINE_ROLE_PLAY,
	},
	{
		genre: EAppsGenreEng.LUCKY,
		counter: EAppsCounters.SHOW_MORE_LUCKY,
		ref: ERefsApps.LINE_LUCKY,
	},
	{
		genre: EAppsGenreEng.STRATEGY,
		counter: EAppsCounters.SHOW_MORE_STRATEGY,
		ref: ERefsApps.LINE_STRATEGY,
	},
	{
		genre: EAppsGenreEng.CASUAL,
		counter: EAppsCounters.SHOW_MORE_CASUAL,
		ref: ERefsApps.LINE_CASUAL,
	},
	{
		genre: EAppsGenreEng.LOGIC,
		counter: EAppsCounters.SHOW_MORE_LOGIC,
		ref: ERefsApps.LINE_LOGIC,
	},
	{
		genre: EAppsGenreEng.ROWS,
		counter: EAppsCounters.SHOW_MORE_ROWS,
		ref: ERefsApps.LINE_THREE_IN_ROW,
	},
];
